import { dropAlimentacao } from 'utils/drops';

const getEquipamentosFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  { name: 'descricao', label: 'Descrição', defaultValue: '', initial: true },
  { name: 'referencia', label: 'Referência', defaultValue: '' },
  {
    name: 'marca',
    label: 'Marca',
    type: 'virtual-select',
    options: drops?.Marca,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'modelo',
    label: 'Modelo',
    type: 'virtual-select',
    options: drops?.Modelo,
    multiple: true,
    defaultValue: [],
  },
  { name: 'patrimonio', label: 'Patrimônio', defaultValue: '' },
  {
    name: 'alimentacao',
    label: 'Alimentação',
    type: 'select',
    options: dropAlimentacao,
    multiple: true,
    defaultValue: [],
  },
];

export default getEquipamentosFilterFields;
